import React, { FC } from 'react';
import { ESQuestion } from '~src/interfaces/question.interface';

import { translateContent } from '~src/services/translationServices';

import { BoxPadding, RowWrapper, TableTitleBox, TitleContainer } from './rows.sc';

interface Props {
  setContainerRef: (e: HTMLDivElement) => void;
  questions: ESQuestion[];
}

const QuestionRow: FC<Props> = props => (
  <RowWrapper>
    <TitleContainer $border ref={props.setContainerRef}>
      {props.questions.map(question => (
        <TableTitleBox key={question.id}>
          <BoxPadding $showFade={translateContent(question.text).length > 70}>
            <div>{translateContent(question.text)}</div>
          </BoxPadding>
        </TableTitleBox>
      ))}
    </TitleContainer>
  </RowWrapper>
);

export default React.memo(QuestionRow);
